module.exports = __webpack_public_path__ + "img/1.763e1dd0.jpg";